import { render } from "./systemPermission.vue?vue&type=template&id=6a5974c6&scoped=true"
import script from "./systemPermission.vue?vue&type=script&lang=js"
export * from "./systemPermission.vue?vue&type=script&lang=js"

import "./systemPermission.vue?vue&type=style&index=0&id=6a5974c6&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5974c6"]])

export default __exports__